// @flow
import { FormattedMessage } from 'react-intl';
import intervalUpdate from '~/core/decorators/interval-update';
import messages from './timer.intl';
import * as React from 'react';
import moment from 'moment-timezone';

import { Container, TimerBox, RemainingBox } from './styles';

type Props = {
    minutes: number,
    seconds?: number,
    now?: Date,
    startFrom?: Date
};

/**
 * Represents a timer that displays a countdown.
 */
export const Timer = ({ minutes, now = new Date(), seconds, startFrom = now }: Props) => {
    const duration = differenceBetweenTimes(now, startFrom, minutes, seconds);

    return (
        <Container>
            <TimerBox>{duration}</TimerBox>
            <RemainingBox>
                <FormattedMessage {...messages.remaining} />
            </RemainingBox>
        </Container>
    );
};

export default intervalUpdate(Timer, 1000);

/**
 * Returns the difference between two times in custom format
 */
const differenceBetweenTimes = (
    start: Date,
    end: Date,
    minutesLimit: number = 0,
    secondsLimit: number = 0,
    format: string = 'mm:ss'
): string => {
    const startTime = moment(start);
    const endTime = moment(end)
        .add(minutesLimit, 'minutes')
        .add(secondsLimit, 'seconds');
    const duration = moment.duration(endTime.diff(startTime));

    return moment.utc(duration.asMilliseconds()).format(format);
};



// WEBPACK FOOTER //
// ./src/components/widgets/timer/timer.component.js